import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '../views/HomePage.vue'
import AboutDetail from '../views/AboutDetail.vue'
import FaqDetail from '../views/FaqDetail.vue'
import LoginPage from '../views/LoginPage.vue'
import UserCenter from '../views/UserCenter.vue'
import AssessmentPage from '../views/AssessmentPage.vue'
import ReportPage from '../views/ReportPage.vue'
import AdminLogin from '../views/AdminLogin.vue'
import AdminPanel from '../views/AdminPanel.vue'
import ContactPage from '../views/ContactPage.vue'
import PolicyPage from '../views/PolicyPage.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'Home', component: HomePage },
  { path: '/about', name: 'About', component: AboutDetail },
  { path: '/faq', name: 'FaqDetail', component: FaqDetail },
  { path: '/contact', name: 'Contact', component: ContactPage },
  { path: '/policy', name: 'Policy', component: PolicyPage },
  { path: '/login', name: 'Login', component: LoginPage },
  { path: '/user/tests', name: 'UserTests', component: UserCenter, meta: { auth: true } },
  { path: '/user/profile', name: 'UserProfile', component: UserCenter, meta: { auth: true } },
  { path: '/assessment', name: 'Assessment', component: AssessmentPage, meta: { auth: true, hideLayout: true } },
  { path: '/report', name: 'Report', component: ReportPage, meta: { auth: true, hideLayout: true } },
  { path: '/manage', name: 'AdminLogin', component: AdminLogin, meta: { hideLayout: true } },
  { path: '/manage/records', name: 'AdminRecords', component: AdminPanel, meta: { hideLayout: true, adminAuth: true } },
  { path: '/manage/config', name: 'AdminConfig', component: AdminPanel, meta: { hideLayout: true, adminAuth: true } },
  { path: '/manage/users', name: 'AdminUsers', component: AdminPanel, meta: { hideLayout: true, adminAuth: true } }
]

const router = new VueRouter({
  mode: 'hash',
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return { selector: to.hash, behavior: 'smooth' }
    }
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta.adminAuth && !localStorage.getItem('admin_token')) {
    next('/manage')
  } else if (to.meta.auth && !localStorage.getItem('token')) {
    next('/login')
  } else {
    next()
  }
})

export default router
